<template>
  <div>
     <vs-dropdown style="margin-left: 5px; cursor: pointer;" vs-custom-content vs-trigger-click>
        <vs-button color="primary" type="border" icon-pack="feather" icon="icon-more-vertical"></vs-button>

        <vs-dropdown-menu style="min-width: 100px;">
          <vs-dropdown-item @click="showPopUpBool = !showPopUpBool">Delete</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <vs-popup
      classContent="popup-example"
      title="Please Confirm"
      :active.sync="showPopUpBool"
    >
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="deleteMethod">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="showPopUpBool = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
export default {
  data () {
    return {
      showPopUpBool: false
    }
  },
  methods: {
    deleteMethod(){
      this.params.colDef.filterParams.deleteSentEmail(this.params.data.id)
      this.showPopUpBool = false
    }
  }

}
</script>